import { createContext, useContext } from 'react';

/**
 * React context used to pass data from a parent route component (e.g., sport page) down to
 * nested child route components without prop drilling. Typically, the provider value contains
 * fields from parent that child is required.
 *
 * @typedef OutletContext
 * @memberof Mojito.Applications.Common
 */
export const OutletContext = createContext();

/**
 * Hook that retrieves the value from the nearest {@link Mojito.Applications.Common.OutletContext|OutletContext} provider.
 *
 * @function useOutletContext
 *
 * @returns {object|null} Value from the nearest `OutletContext.Provider`, or undefined when no provider exists above in the tree.
 * @memberof Mojito.Applications.Common
 */
export function useOutletContext() {
    return useContext(OutletContext);
}
